import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import LangUtils from '../../../../common/js/LangUtils.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

import contactEmail from '../../../../common/js/handlebars/contactEmail.js';

import RESULT_DE_TEMPLATE from './ActivationWidget-result-de.hbs';
import RESULT_EN_TEMPLATE from './ActivationWidget-result-en.hbs';

export default class ActivationWidget extends Widget {

	constructor($widget) {
		super($widget);

		Form.onSubmit($widget, action => {
			Ajax.rpc('/activate', {
				request: action.findField('request').val()
			}, response => {
				action.ok();
				if (response.result == 'SUCCESS') {
					this.showSuccess(response.cipherString);
				} else if (response.result == 'NO_MORE_LICENSES') {
					this.showLicenseError();
				} else {
					this.showInvalidCodeError();
				}
			}, () => {
				action.error();
				this.showTechnicalError();
			});
		});
	}

	showInvalidCodeError() {
		if (LangUtils.isGerman()) {
			MessageUtils.error(this.$widget.find('.js_messages'),
				'Der Code, den du eingegeben hast, ist ungültig. War dies wirklich eine Aktivierungsanfrage?\n'
				+ 'Solltest du Unterstützung benötigen, kontaktiere mich bitte unter ' + contactEmail() + '.');
		} else {
			MessageUtils.error(this.$widget.find('.js_messages'),
				'The code you entered is invalid. Was this really an activation request?\n'
				+ 'If you need support, please contact me at ' + contactEmail() + '.');
		}
	}

	showSuccess(cipherString) {
		if (LangUtils.isGerman()) {
			this.setPageHeadline('Lizenzschlüssel erfolgreich aktiviert');
			this.$widget.html(RESULT_DE_TEMPLATE(cipherString));
		} else {
			this.setPageHeadline('License key activated successfully');
			this.$widget.html(RESULT_EN_TEMPLATE(cipherString));
		}
	}

	showTechnicalError() {
		if (LangUtils.isGerman()) {
			MessageUtils.error(this.$widget.find('.js_messages'),
				'Aktivieren der Lizenz fehlgeschlagen. Bitte versuch es später noch einmal.\n'
				+ 'Wenn das Problem bestehen bleibt, kontaktiere mich bitte unter ' + contactEmail() + '.');
		} else {
			MessageUtils.error(this.$widget.find('.js_messages'),
				'Failed to activate your license. Please try again later.\n'
				+ 'If the problem persists, please contact me at ' + contactEmail() + '.');
		}
	}

	showLicenseError() {
		if (LangUtils.isGerman()) {
			MessageUtils.error(this.$widget.find('.js_messages'),
				'Die maximale Anzahl Aktivierungen für diesen Lizenz-Schlüssel ist leider bereits erreicht.\n'
				+ 'Solltest du Unterstützung benötigen, kontaktiere mich bitte unter ' + contactEmail() + '.');
		} else {
			MessageUtils.error(this.$widget.find('.js_messages'),
				'Unfortunatelly, you have reached the maximum number of activations for this license key.\n'
				+ 'If you need support, please contact me at ' + contactEmail() + '.');
		}
	}

}
